/**
 * Shared price + currency-code formatting for every screen that shows a
 * charge amount (passes, checkout success, wallet). Keeping this in one
 * place means the visible code and its screen-reader name can't drift
 * apart between screens — Stripe's charge currency must always match what's
 * printed here.
 */

const CURRENCY_NAMES: Record<string, string> = {
  USD: "US dollars",
  MXN: "Mexican pesos",
};

export function currencyName(code: string): string {
  return CURRENCY_NAMES[code.toUpperCase()] ?? code.toUpperCase();
}

export function formatAmount(cents: number): string {
  const v = cents / 100;
  return Number.isInteger(v) ? `$${v.toLocaleString("en-US")}` : `$${v.toFixed(2)}`;
}

/** "150 US dollars" — for the aria-label wrapping an amount + currency code. */
export function priceAriaLabel(cents: number, currency: string): string {
  const v = cents / 100;
  const n = Number.isInteger(v) ? v.toLocaleString("en-US") : v.toFixed(2);
  return `${n} ${currencyName(currency)}`;
}
